
export default {
  name: 'FormWrapper',
  template: `<component
              ref="component"
              :style="extraStyle"
              :is="formConfig.component"
              v-model="formConfig.value"
              v-bind="formConfig"
              @on-return="$emit('on-return', $event)"
              @change="$emit('change', $event)"
              />`,
  props: ['formConfig'],
  data () {
    return {
      loaded: false
    };
  },
  methods: {
    component () {
      if (this.$refs) {
          this.loaded = true;
          return this.$refs.component;
      }
    }
  },
  computed: {
    extraStyle() {
      return (this.formConfig.noWrappers) ?
          'display: inline-block; width: 100%; margin:0;' : '';
    }
  }
};
